import { render, staticRenderFns } from "./Block.vue?vue&type=template&id=06572eb2"
import script from "./Block.vue?vue&type=script&lang=js"
export * from "./Block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06572eb2')) {
      api.createRecord('06572eb2', component.options)
    } else {
      api.reload('06572eb2', component.options)
    }
    module.hot.accept("./Block.vue?vue&type=template&id=06572eb2", function () {
      api.rerender('06572eb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Block.vue"
export default component.exports